import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class HomeSelectionSharedService {
  clearSearch(ctx: any) {
    ctx.homeLocation = '';
  }

  getLanguage(ctx: any) {
    ctx.appservice.getlang().subscribe((res) => {
      if (res && res['commonMsg']) {
        ctx.selectedlang = res['commonMsg'];
      }
    });
  }

  onToggleCalendar(ctx: any, event: any): void {
    event.stopPropagation();
    ctx.mydp.openBtnClicked();
  }

  onToggleCalendar1(ctx: any, event: any): void {
    event.stopPropagation();
    ctx.mydp1.openBtnClicked();
  }

  validate(ctx: any, schedDate) {
    if (schedDate != null) {
      const validDate = moment(schedDate, 'MMM DD,YYYY').isValid();
      if (validDate) {
        if (moment().diff(schedDate) <= 0) {
          ctx.showErrDate = false;
        } else {
          ctx.showErrDate = true;
        }
      } else {
        ctx.showErrDate = true;
      }
    }
  }

  addSelectProcedureList(ctx: any) {
    ctx.selectProcedureList.push({
      examId: '',
      bodyPartList: [],
      bodyPartId: '',
      procedureList: [],
      cptCode: '',
      procedureName: '',
      open: false,
    });
  }

  selectMultipleProcedure(ctx: any) {
    ctx.homeinfosubmit = false;
    ctx.multiplePro = true;
    ctx.addSelectProcedureList();
  }

  findpaymode(ctx: any) {
    if (ctx.homeInsurance === 'self') {
      ctx.paymode = 'self';
    } else {
      ctx.paymode = 'insurance';
    }
  }

  cptcodeChange(ctx: any, value, index) {
    if (value && value.toString().length === 5) {
      let isExist = false;
      if (ctx.selectProcedureList && ctx.selectProcedureList.length > 0) {
        for (let s = 0; s < ctx.selectProcedureList.length; s++) {
          if (ctx.selectProcedureList[s].cptCode === value) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          ctx.getallExamListOnchange(value, index);
        } else {
          ctx.toastr.error('Procedure already selected');
          ctx.selectProcedureList[index].bodyPartId = '';
          ctx.selectProcedureList[index].cptCode = '';
          ctx.selectProcedureList[index].bodyPartName = '';
          ctx.selectProcedureList[index].procedureName = '';
          ctx.selectProcedureList[index].procedureList = [];
        }
      } else {
        ctx.getallExamListOnchange(value, index);
      }
    }
  }

  redirectToLocation(ctx: any) {
    ctx.router.navigate(['/metro', ctx.countryCode]);
  }

  formatHomeDate(date: any) {
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    let day = date.getDate();
    if (day && day < 10) {
      day = '0' + day;
    }
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return monthNames[monthIndex] + ' ' + day + ',' + year;
  }

  getRoundedDate(minutes: any, d: any = new Date()) {
    const ms = 1000 * 60 * minutes; // convert minutes to ms
    const roundedDate = new Date(Math.round(d.getTime() / ms) * ms);
    return roundedDate;
  }

  getOffsetZone(ctx: any, latitude, longitude, type) {
    ctx.appservice.getTimeZoneByLatLng(latitude, longitude).subscribe(
      (res) => {
        if (res && res['status'] == 'OK') {
          if (type === 101) {
            if (res['rawOffset'] != 0) {
              ctx.timeZone = +((+res['rawOffset']) / 60);
            }
          } else if (res['rawOffset'] != 0) {
            var dstOffset = 0;
            if (res['dstOffset'] != 0) {
              dstOffset = +((+res['dstOffset']) / 60);
            }

            ctx.timeZone = +(+((+res['rawOffset']) / 60) + (+dstOffset) + 60);
          }
        }
        console.log(ctx.timeZone);
      },
      (err) => ({})
    );
  }

  convetTimeZoneOffsetToTime(ctx: any) {
    ctx.timezone_offset_min = new Date().getTimezoneOffset();
    ctx.offset_hrs = Math.abs(ctx.timezone_offset_min / 60);
    ctx.offset_min = Math.abs(ctx.timezone_offset_min % 60);
    let timezone_standard = '';

    if (ctx.offset_hrs < 10) {
      ctx.offset_hrs = '0' + Math.floor(ctx.offset_hrs);
    }

    if (ctx.offset_min < 10) {
      ctx.offset_min = '0' + ctx.offset_min;
    }

    // Add an opposite sign to the offset
    // If offset is 0, it means timezone is UTC
    if (ctx.timezone_offset_min < 0) {
      timezone_standard =
        '+' + ctx.offset_hrs.toString() + ':' + ctx.offset_min.toString();
    } else if (ctx.timezone_offset_min > 0) {
      timezone_standard =
        '-' + ctx.offset_hrs.toString() + ':' + ctx.offset_min.toString();
    } else if (ctx.timezone_offset_min === 0) {
      timezone_standard = '+00:00';
    }
    return timezone_standard.toString();
  }

  removeSelectProcedureListMob(ctx: any, index) {
    if (index === 0) {
      ctx.selectProcedureList.splice(index, 1);
    } else {
      ctx.selectProcedureList.splice(index, 1);
    }
    if (ctx.selectProcedureList && ctx.selectProcedureList.length === 1) {
      ctx.multiplePro = false;
    }

    if (ctx.selectProcedureList && ctx.selectProcedureList.length >= 5) {
      ctx.showAddProcedureFormMob = false;
    } else {
      ctx.showAddProcedureFormMob = true;
    }
  }

  openpopuptemplateonchanged(ctx: any, procedures, cptcode, ind) {
    if (ctx.selectProcedureList && ctx.selectProcedureList.length > 0) {
      for (let s = 0; s < ctx.selectProcedureList.length; s++) {
        if (s !== ind) {
          ctx.selectProcedureList[s].open = false;
        }
      }
    }
    ctx.selectIndex = ind;
    if (procedures && procedures.length > 0) {
      ctx.selectProcedureList[ind].open = false;
      for (let index = 0; index < procedures.length; index++) {
        if (procedures[index].cptCode === cptcode) {
          procedures[index].checked = true;
        }
      }
      ctx.popProcedures = procedures;
    } else {
      ctx.popProcedures = [{ id: '', cptCode: '', procedureName: '' }];
      ctx.selectProcedureList[ind].open = false;
    }
  }

  changeHomeCptCode(ctx: any, procedure) {
    ctx.selectProcedureList[0].cptCode = procedure.cptCode;
    ctx.selectProcedureList[0].procedureName = procedure.procedureName;
    ctx.modalRef.hide();
  }

  isProcedureSelectionValid(ctx: any) {
    let valid = true;
    if (
      ctx.homeDate &&
      ctx.homeLocation &&
      ctx.homeInsurance &&
      ctx.selectProcedureList &&
      ctx.selectProcedureList.length > 0
    ) {
      for (var i = 0; i < ctx.selectProcedureList.length; i++) {
        if (
          ctx.selectProcedureList[i].examId &&
          ctx.selectProcedureList[i].bodyPartId &&
          ctx.selectProcedureList[i].cptCode
        ) {
          //this.cptCodeList.push(this.selectProcedureList[i].cptCode);
        } else {
          valid = false;
          break;
        }
      }
    } else {
      valid = false;
    }
    return valid;
  }

  /**
   * Jackson 3 may serialize ScheduleTimeList as "ProcedureInputs" (capital P).
   * Angular expects "procedureInputs" — normalize so slot labels and booking work.
   */
  normalizeScheduleSlot(slot: any): any {
    if (!slot) {
      return slot;
    }
    if (!slot.procedureInputs && slot.ProcedureInputs) {
      slot.procedureInputs = slot.ProcedureInputs;
    }
    return slot;
  }

  normalizeScheduleSlots(slots: any[]): any[] {
    if (!slots || !slots.length) {
      return slots;
    }
    return slots.map((s) => this.normalizeScheduleSlot(s));
  }

  normalizeTestCenterSchedules(testCenters: any[]): any[] {
    if (!testCenters || !testCenters.length) {
      return testCenters;
    }
    testCenters.forEach((tc) => {
      if (tc && tc.schedules) {
        tc.schedules = this.normalizeScheduleSlots(tc.schedules);
      }
    });
    return testCenters;
  }
}
